<template>
    <div>
        <loading v-bind:dspin="!contentLoaded"></loading>

        <modal v-if="false">
            <template slot="header">Processing Request</template>

            <template slot="body0">
                <div>
                    <ul class="w3-large flow-blue-color font-weight-bold">
                        <li v-bind:class="clearingRoom !== true ? 'w3-disabled process-check' : ''">
                            Clearing room
                            <i class="fa fa-check flow-green-active-color flow-margin-left"></i>
                        </li>
                        <li v-bind:class="changingGroup !== true ? 'w3-disabled process-check' : ''">
                            Changing room's group
                            <i class="fa fa-check flow-green-active-color flow-margin-left"></i>
                        </li>
                        <li v-bind:class="linkingRoom !== true ? 'w3-disabled process-check' : ''">
                            Linking room to physician
                            <i class="fa fa-check flow-green-active-color flow-margin-left"></i>
                        </li>
                    </ul>
                </div>
            </template>

            <template slot="body1">
                <span class="w3-xlarge">
                    <span v-if="clearingRoom === true && changingGroup === true && linkingRoom === true">
                        Success
                    </span>

                    <span v-else-if="clearingRoom === false || changingGroup === false && linkingRoom === false">
                        Failed
                    </span>

                    <span v-else>
                        Processing . . .
                    </span>
                </span>
            </template>
        </modal>

        <table class="w3-table w3-bordered flow-table patients-table" v-if="contentLoaded">
            <thead class="flow-blue-color">
            <th>{{ $t("room") }}</th>
            <th>{{ $t("physician") }}</th>
            <th>{{ $t("consultationGroup") }}</th>
            <th>{{ $t("actions") }}</th>
            </thead>
            <tbody v-show="rooms.length === 0">
            <tr>
                <td colspan="8" class="w3-center flow-blue-color">
                    <b class="font-size-1pt25em">{{$t("noRooms")}}</b>
                </td>
            </tr>
            </tbody>
            <tbody  v-show="rooms.length !== 0">
                <tr v-for="entry in rooms"
                    v-bind:id="entry.room.id" v-bind:class="alteringRoomId === entry.room.id ? 'w3-disabled' : ''">

                    <td class="primary">
                        <span v-if="isNormal" v-show="entry.room.name">{{entry.room.name}}</span>
                        <router-link v-else :to="{name: 'room', params: {roomId: entry.room.id}}" :title="entry.room.name">
                            <span v-show="entry.room.name">{{entry.room.name}}</span>
                        </router-link>
                    </td>

                    <td style="min-width: 45%">
                        <span v-if="entry.physician">{{entry.physician.name }}</span>
                        <span v-else class="flowselect">
                            <select v-model="selectedPhysician[entry.room.id]">
                                <option selected v-bind:value="undefined">{{ $t("none") }}</option>
                                <option v-for="p in physicians" v-bind:value="p.id">
                                    {{ p.name }}
                                </option>
                            </select>
                            <i class="fa fa-chevron-down flow-green-active-color"></i>
                        </span>
                    </td>

                    <td style="min-width: 20%">
                        <span v-if="!showUnlink(entry)" class="flowselect">
                            <select v-model="selectedGroup[entry.room.id]" class="cursor-pointer">
                                <option v-for="g in groups" v-bind:value="g.id === entry.room.group.id ? undefined : g.id">
                                    {{ g.displayName }}
                                </option>
                            </select>
                            <i class="fa fa-chevron-down flow-green-active-color"></i>
                        </span>

                        <span v-else>
                            {{ entry.room.group.displayName }}
                        </span>
                    </td>

                    <td>
                        <span v-if="alteringRoomId === entry.room.id">
                            <i class="fa fa-spinner w3-spin w3-xlarge w3-margin-left w3-opacity w3-disabled transform-animation"></i>
                        </span>

                        <span v-else>
                            <span>
                                <span v-if="showUnlink(entry)" @click="unlink(entry)" class="cursor-pointer">
                                    <i class="fa fa-times-circle w3-large w3-text-red"></i>
                                    <span class="flow-green-active-color flow-margin-left font-weight-bold w3-large">{{ $t('confirm') }}</span>
                                </span>


                                <span v-else>
                                    <span v-bind:class="showLink(entry) ? 'cursor-pointer' : 'w3-disabled'" @click="link(entry)">
                                        <i class="fa fa-check-circle w3-large flow-green-active-color"></i>
                                        <span class="flow-green-active-color flow-margin-left font-weight-bold w3-large">{{ $t('confirm') }}</span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Vue from 'vue';
import Loading from "../common/Loading";
import {EventBus} from "../../main";
import FlowSelect from "../../components/common/FlowSelect";
import Modal from "../common/Modal";

let frc = Vue.prototype.$frc;

    export default {
        name: "ConsultationRooms",
        components: {Modal, Loading, FlowSelect},
        props: ['physicians'],
        data: function(){
            return{
                contentLoaded: false,
                rooms: [],
                groups: [],
                selectNone: {id: 'none', name: this.$t("none")},
                wardId: undefined,
                alteringRoomId: undefined,
                selectedPhysician: {},
                selectedGroup: {},
                showModal: false,
                clearingRoom: undefined,
                changingGroup: undefined,
                linkingRoom: undefined
            }
        },
        computed: {
            isNormal() {
                return Vue.isNormal(Vue.prototype.$currentUser.user.role);
            }
        },
        watch: {
            rooms() {
                this.selectedPhysician = {};
                this.alteringRoomId = undefined;
                this.selectedAction = {};
                this.selectedGroup = {};
            }
        },
        mounted() {
            this.wardId = Vue.prototype.$currentWard.id;

            if (!this.wardId) {
                Vue.notifyError({
                    title: this.$t("WARD_NOT_FOUND")
                });

                return;
            }

            this.getConsultationRooms();
            this.getGroupsInWard();
            EventBus.$on("wardUpdated", this.getRoomOnWardUpdate);
            EventBus.$on("modalClosed", this.modalClosed);
        },
        beforeDestroy() {
            EventBus.$off("wardUpdated", this.getRoomOnWardUpdate);
            EventBus.$off("modalClosed", this.modalClosed);
        },
        methods: {
            modalClosed() {
                this.showModal = false;

                this.clearingRoom = undefined;
                this.changingGroup = undefined;
                this.linkingRoom = undefined;

            },
            getRoomOnWardUpdate() {
                this.wardId = Vue.prototype.$currentWard.id;
                this.getConsultationRooms();
                this.getGroupsInWard();
            },
            getConsultationRooms() {
                var app = this;

                frc.getConsultationRoomsInWard(app.wardId, false).then(function (res) {
                    app.rooms = res.data;
                    app.rooms.sort(function (a, b) {
                        return a.room.name.localeCompare(b.room.name);
                    });
                    app.contentLoaded = true;
                });
            },
            getGroupsInWard() {
                var app = this;

                frc.getConsultationGroupsInWard(app.wardId).then(function (res) {
                    app.groups = res.data.filter(function (g) {
                        return g.shareRooms === false;
                    });
                });
            },
            linkRoom(eachRoom) {
                var app = this;
                var phyId = app.selectedPhysician[eachRoom.room.id];

                frc.linkRoomToPhysician(app.wardId, phyId, eachRoom.room.id).then(function (res) {
                    app.changeAndNotify("successfullyLinkedRoom");
                }).catch(app.unsetAlteringRoom);
            },
            changeGroup(entry) {
                var group = this.selectedGroup[entry.room.id];
                var phy = null;

                if (this.isNormal) {
                    phy = Vue.getUserAGSPhysicianId();
                } else {
                    phy = this.selectedPhysician[entry.room.id];
                    if (!phy) {
                        phy = entry.physician.id;
                    }
                }

                if (!group || !phy) {
                    Vue.notifyError({
                        title: "Select physician and group"
                    });
                    return;
                }

                var app = this;
                app.showModal = true;

                frc.clearRoom(app.wardId, entry.room.id).then(function (res) {
                    app.clearingRoom = true;
                    frc.changeRoomGroup(app.wardId, group, entry.room.id).then(function (res) {
                        app.changingGroup = true;
                        frc.linkRoomToPhysician(app.wardId, phy, entry.room.id).then(function (res) {
                            app.changeAndNotify("successfullyLinkedRoom");
                            app.linkingRoom = true;
                        }).catch(function () {
                            app.linkingRoom = false;
                        });
                    }).catch(function() {
                        app.changingGroup = false;
                    });
                }).catch(function() {
                    app.clearingRoom = false;
                });

            },
            unsetAlteringRoom(room) {
                this.alteringRoomId = undefined;
            },
            setAlteringRoom(room) {
                this.alteringRoomId = room.id;
            },
            changeAndNotify(message) {
                this.getConsultationRooms();
                Vue.notifySuccess({title: this.$t(message)});
                EventBus.$emit("roomChanged");
            },
            link(entry) {
                const rid = entry.room.id;

                if (this.selectedGroup[rid] && this.selectedPhysician[rid]) {
                    this.changeGroup(entry);
                } else if (this.selectedPhysician[rid]) {
                    this.linkRoom(entry);
                }
            },
            unlink(entry) {
                var app = this;

                frc.unlinkRoomFromPhysician(app.wardId, entry.physician.id, entry.room.id).then(function (res) {
                    frc.resetRoomGroup(app.wardId, entry.room.id).then(function (res) {
                        app.changeAndNotify("successfullyUnlinkedRoom");
                    }).catch(function () {
                        app.unsetAlteringRoom();
                        Vue.notifyError({
                            message: "Failed to reset room's group"
                        });
                    });
                }).catch(app.unsetAlteringRoom);
            },
            showLink(entry) {
                const rid = entry.room.id;
                return (entry.physician || this.selectedPhysician[rid]) && ((entry.room && entry.room.group) || this.selectedGroup[rid]);
            },
            showUnlink(entry) {
                return entry.physician;
            }
        }
    }
</script>

//TODO make scoped or move to css file
<style>
    span.flowselect {
        border: 1px solid lightgrey;
        border-radius: 4px;
        padding: 4px 8px 8px 4px;
    }

    option {
        padding: 16px 32px 32px 16px;
        margin: auto;
        color: black !important;
    }

    select {
        padding: 4px 8px 8px 4px;
        background: transparent;
        border-radius: 4px;
        /* for Firefox */
        -moz-appearance: none;
        /* for Chrome */
        -webkit-appearance: none;
        box-shadow: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        border: none;
    }

    /* For IE10 */
    select::-ms-expand {
        display: none;
    }

    select:focus {
        color: transparent;
        text-shadow: 0 0 0 #000;
        box-shadow: none;
    }

    select:hover, option:hover {
        cursor: pointer;
    }

    span.flowselect i {
        cursor: text;
    }

    .process-check i {
        display: none;
    }
</style>